<!--ESEMPIO templateOutlet-->
<!--<ng-template #customHeader let-data="data">
<span>sono il customHeader {{ data }}</span>
</ng-template>

<span *ngFor="let item of exampleData; let i = index">
<ng-container
        [ngTemplateOutlet]="customHeader"
        [ngTemplateOutletContext]="{data: item}"
></ng-container>
</span>-->


<div class="table-responsive bg-white table-padding table-radius mb-2 shadow-sm"
     [ngClass]="{'padding-noText': !tableText}">
    
    <div *ngIf="tableText" class="table-text">
        <div class="d-flex flex-column justify-content-start" *ngIf="tableTitle.length > 0 || tableDescription.length > 0">
            <span *ngIf="tableTitle.length > 0" class="table-title">{{ tableTitle }}</span>
            <span *ngIf="tableDescription.length > 0" class="table-description">{{ tableDescription }}</span>
        </div>
        <div class="button-search-container" *ngIf="addButtonText !== '' || allowSearch || deleteButtonText !== '' || editButtonText !== '' || printButtonText !== ''">
            <div class="search-elements" *ngIf="allowSearch">
                <input type="text" class="form-control form-control-solid" placeholder="Cerca..." [(ngModel)]="searchText" (keyup.enter)="searchElement()"/>
                <button class="btn btn-primary" (click)="searchElement()">
                    Cerca
                </button>
                <button class="btn btn-reset-link" (click)="resetSearch()">
                    Reset
                </button>
            </div>

            <button class="btn btn-primary" *ngIf="addButtonText !== '' "
                    (click)="addElement()">{{ addButtonText }}</button>

            <button class="btn welldone-btn-danger" *ngIf="deleteButtonText !== '' "
                    (click)="deleteElement()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
                    class="bi bi-trash" viewBox="0 0 16 16">
                   <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                   <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
               </svg>
            </button>

            <button class="btn welldone-btn-gray" *ngIf="editButtonText !== '' "
                    (click)="editElement()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                </svg>
            </button>

            <button class="btn welldone-btn-light" *ngIf="printButtonText !== '' "
                    (click)="printElement()">
                <i class="bi bi-printer me-2"></i>{{ printButtonText }}
            </button>

        </div>
    </div>

    <div *ngIf="customFilterRef" class="table-filter-container">
        <ng-container [ngTemplateOutlet]="customFilterRef"></ng-container>
    </div>
    <!-- Loading / data / empty states -->
    <ng-container *ngIf="loading; else tableOrNoData">
        <!-- Custom loading template if provided by the parent -->
        <ng-container *ngIf="customLoadingRef; else defaultLoading"
                      [ngTemplateOutlet]="customLoadingRef">
        </ng-container>
        <!-- Fallback generic loading -->
        <ng-template #defaultLoading>
            <div class="flex items-center justify-center py-6">
                <div class="flex items-center gap-3 text-slate-500 text-sm">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Caricamento...</span>
                    </div>
                    <span>Caricamento dati...</span>
                </div>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #tableOrNoData>
        <ng-container *ngIf="rows.length; else noData">
            <div class="table-scroll">
                <table class="table custom-ui-table" [ngClass]="{'table-striped': striped}">
                    <thead>
                    <ng-container
                            [ngTemplateOutlet]="customHeaderRef"
                    ></ng-container>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let row of rows">
                        <ng-container
                                [ngTemplateOutlet]="customRowRef"
                                [ngTemplateOutletContext]="{row: row}"
                        ></ng-container>
                    </ng-container>

                    <ng-container *ngIf="shopTable">
                        <tr>
                            <td colspan="10" class="separator-row">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colspan="20" class="text-center">
                                <div class="button-search-container">
                                    <div class="text-container">
                                        <h5><strong>Totale parziale: <span class="text-nowrap">{{ shopSubTotal }}&nbsp;€</span></strong></h5>
                                        <p>Tasse incluse e spese di spedizione calcolate al momento del pagamento</p>
                                    </div>
                                    <button class="btn btn-primary">Checkout</button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </ng-template>
    <ng-template #noData>
        <div class="no-data-container">
            <img src="assets/icons/info-circle-fill.svg" alt="no data" class="no-data-icon">
            <span class="no-data-text">Nessun elemento trovato</span>
        </div>
    </ng-template>
</div>


<nav aria-label="Page navigation example" class="mb-5" *ngIf="!loading">
    <ul class="pagination">
        <li class="page-item" [ngClass]="{'disabled': currentPage === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="previousPagePagination()" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
            </a>
        </li>
        <li class="page-item" *ngFor="let page of getPagesArray()">
            <a class="page-link" href="javascript:void(0)"
               (click)="page === -1 ? loadPageGroup('prev') : page === -2 ? loadPageGroup('next') : loadPage(page - 1)"
               [ngClass]="{'active': currentPage === page - 1}">
                {{ page === -1 || page === -2 ? '...' : page }}
            </a>
        </li>
        <li class="page-item" [ngClass]="{'disabled': currentPage === pagesCount - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="nextPagePagination()" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
            </a>
        </li>
    </ul>
</nav>

<!--<ngx-smart-modal #addUser identifier="addUser">
    <div class="container-fluid">
        <div class="welldone-card-header">Aggiungi utente</div>
        <div class="welldone-card-body">
            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-4">
                        <label for="userFirstName" class="form-label required">Nome utente </label>
                        <input type="text" class="form-control form-control-solid" id="userFirstName"
                               [(ngModel)]="newUser.firstName">
                    </div>
                    <div class="col-4">
                        <label for="userLastName" class="form-label required">Cognome utente </label>
                        <input type="text" class="form-control form-control-solid" id="userLastName"
                               [(ngModel)]="newUser.lastName">
                    </div>
                    <div class="col-4">
                        <label for="userEmail" class="form-label required">Indirizzo email </label>
                        <input type="email" class="form-control form-control-solid" id="userEmail"
                               [(ngModel)]="newUser.email">
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label for="userPassword" class="form-label required">Password </label>
                        <input type="password" class="form-control form-control-solid" id="userPassword"
                               [(ngModel)]="newUser.password">
                    </div>
                    <div class="col-6">
                        <label for="confirmPassword" class="form-label required">Conferma password </label>
                        <input type="password" class="form-control form-control-solid" id="confirmPassword" #confirmPassword>
                    </div>
                </div>
            </div>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-primary" (click)="createUser()" [disabled]="isUserNotValid()"> Crea </button>
        </div>
    </div>

</ngx-smart-modal>-->


<ngx-smart-modal identifier='successModal'>
    <div class="welldone-card-header">Operazione riuscita</div>
    <div class="welldone-card-body">
        <div class="d-flex align-items-center gap-3">
            <i class="bi bi-check-circle-fill text-success fs-1"></i>
            <span class="fs-5 fw-bold">Operazione eseguita con successo</span>
        </div>
    </div>
    <div class="welldone-card-footer">
        <button class="btn btn-primary px-5" (click)="modal.getModal('successModal').close()">OK</button>
    </div>
</ngx-smart-modal>

<ngx-smart-modal identifier='errorModal'>
    <div class="welldone-card-header text-danger">Errore</div>
    <div class="welldone-card-body">
        <div class="d-flex align-items-center gap-3">
            <i class="bi bi-exclamation-triangle-fill text-danger fs-1"></i>
            <span class="fs-5 fw-bold">C'è stato un errore nell'operazione</span>
        </div>
    </div>
    <div class="welldone-card-footer">
        <button class="btn btn-secondary px-5" (click)="modal.getModal('errorModal').close()">Chiudi</button>
    </div>
</ngx-smart-modal>
